var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallpaperDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 740",
    fill: "none",
    preserveAspectRatio: "xMinYMin slice",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wallpaper-default_svg__paint0_radial)",
    d: "M0 0h375v740H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "wallpaper-default_svg__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(89.937 -91.453 278.853) scale(341 196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#1A3248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091C2D"
  })))));
}

export default SvgWallpaperDefault;